module.exports = __webpack_public_path__ + "assets/img/event2.446d3692.png";